export default __webpack_public_path__ + "static/assets/im_create_restriction.6fbddc2844ea239897e9e3c08567cca8.png";